import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatSetsYourFirmApartInHandlingProbateMattersPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-sets-your-firm-apart-in-handling-probate-matters/']} />;
}
